import { cn } from "@btnet/utilities-core";

import {
    stickyHeaderHeightActions,
    stickyHeaderHeightTitle,
    stickyHeaderLevelActions,
    stickyHeaderLevelTitle,
    type StickyHeaderType,
} from "commonComponents/btWrappers/BTListLayout/BTListLayoutHeader";
import { useGridContainerStickyHeight } from "commonComponents/utilities/Grid/useGridContainerStickyHeight";
import { useStickyHeight } from "commonComponents/utilities/StickyContext";

import "./GridContainerHeader.less";

interface IGridContainerHeaderProps {
    className?: string;
    content: React.ReactNode;
    stickyHeader?: StickyHeaderType;
    autoHeight?: boolean;
}

export const GridContainerHeader: React.FunctionComponent<IGridContainerHeaderProps> = (props) => {
    const { className, stickyHeader = "Title", autoHeight = false } = props;

    const headerRef = useGridContainerStickyHeight("--grid-container-header-height");

    const isTitle = stickyHeader === "Title";

    const stickyHeaderHeight = isTitle ? stickyHeaderHeightTitle : stickyHeaderHeightActions;
    const stickyHeaderLevel = isTitle ? stickyHeaderLevelTitle : stickyHeaderLevelActions;
    const top = useStickyHeight(stickyHeaderHeight, "top", stickyHeaderLevel);

    const combinedClasses = cn(className, "GridContainer-Header StickyLayoutHeader", {
        isTitle: !isTitle,
    });

    return (
        <div
            ref={headerRef}
            className={combinedClasses}
            style={{ height: !autoHeight ? stickyHeaderHeight : "auto", top }}
            data-testid="grid-container-header"
        >
            {props.content}
        </div>
    );
};
